import { FormatNumber } from '../../../libraries/formatNumber';

class BuildIncludedServices 
{
    constructor(upload = function(){}){
        this.additionals = [];
        this.additionals_object = {};
        this.additionals_names = [];
        this.upload = upload;
    }
    GetAdditionalsInterface(){
        let AdditionalInterface = {
            video: {
                title: window.get_contents_all("ctn_MjrYo7") ?? "Administrador de videos",
                icon: "icon-tripod-folder-video",
                video_max_impressions: 10000,
                video_storage: 1, // GB
            },
            tokens_ia: {
                title: window.get_contents_all("ctn_79dyKR") ?? "Generador de contenidos",
                icon: "x-outline-magicpen",
                value: 7000
            },
            academy: {
                title: window.get_contents_all("ctn_XzWd7s") ?? "Academia 3Pod",
                icon: "icon-tripod-T-3PodAcademy",
                value: true
            },
            editor: {
                title: window.get_contents_all("ctn_gRR5hL") ?? "Editor de diseños",
                icon: "icon-tripod-v-pen-tool",
                value: true
            }
        };
    
        return AdditionalInterface;
    }
    build_additional(plan){
        let app = this;
        let tokens_ia = plan?.benefits?.tokens_ia?.value ?? 7000;
        
        let data = {
            id_plan: plan.id_plan,
            video: {
                video_max_impressions: plan.video_max_impressions,
                video_storage: plan.video_storage,
                text: `${plan.video_storage}GB & ${FormatNumber(plan.video_max_impressions)} ${window.get_contents_all("ctn_Or7fTw") ?? "reproducciones"}`
            },
            tokens_ia: {
                value: tokens_ia,
                text: `${FormatNumber(tokens_ia)} tokens`
            },
            academy: {
                value: true,
            },
            editor: {
                value: true,
            },
        }

        app.additionals.push(data);

        app.additionals_object[plan.id_plan] = data;
    
        app.additionals = [...app.additionals];
        Object.values(app.GetAdditionalsInterface()).forEach((value, key)=>{
            let name = Object.keys(app.GetAdditionalsInterface())[key];
            app.additionals_names.push(name);
        });

        app.upload();
    }
    set_additional_benefit(plan, additional_type){
        let output = "";
        this.additionals.forEach((additional)=>{
            if(additional.id_plan === plan.id_plan){
                output = additional[additional_type]?.text ?? "";
            }
        })
    
        return output;
    }
}

export {BuildIncludedServices}